<template>
    <aside class="navbar-aside" id="offcanvas_aside">
        <div class="aside-top">
            <router-link to="/" class="brand-wrap">
                <img src="../../assets/imgs/logo.svg" class="logo" alt="E-Commerce Admin Panel">
            </router-link>
            <div>
                <button class="btn btn-icon btn-aside-minimize"> <i class="text-muted material-icons md-menu_open"></i> </button>
            </div>
        </div>
        <nav>
            <ul class="menu-aside">
                <li v-if="canView('view_dashboard')" class="menu-item" value="12" :class="[{'active': currentpage(['dashboard'])}]">
                    <router-link class="menu-link" to="/">
                        <i class="icon material-icons md-home"></i>
                        <span class="text">{{ $t("common.dashboard") }}</span>
                    </router-link>
                </li>
                <li v-if="canView('view_order')" class="menu-item has-submenu" :class="[{'active': currentpage(['order_list'])}]" >
                    <a  class="menu-link"> <i class="icon material-icons md-shopping_cart"></i>
                        <span class="text">{{ $t("order.orders") }}</span>
                    </a>
                    <div v-if="canView('view_dashboard')" class="submenu">
                        <router-link to="/order-list">{{ $t("order.order_list") }}</router-link>
                    </div>
                </li>
                 
                <li v-if="canView('create_consignment') || canView('view_consignment')" class="menu-item has-submenu" :class="[{'active': currentpage(['create_consignment', 'manage_consignment', 'manage_reconsignment'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-local_shipping"></i>
                        <span class="text">{{ $t("consignment.consignment") }}</span>  
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_consignment')" to="/create-consignment">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_consignment')" to="/manage-consignment">{{ $t("common.manage") }}</router-link>
                    </div>
                </li>
                <hr v-if="canView('create_product_category') || canView('view_product_category')">
                <h6 v-if="canView('create_product_category') || canView('view_product_category')">
                    {{ $t("common.settings") }}
                </h6>
                <li v-if="canView('create_product_category') || canView('view_product_category')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_product_category', 'manage_categories', 'edit_product_category'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-category"></i>
                        <span class="text">{{ $t("product_category.product_categories") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_product_category')" to="/add-product-category">{{ $t("product_category.add_product_category") }}</router-link>
                        <router-link v-if="canView('view_product_category')" to="/manage-categories">{{ $t("product_category.manage_categories") }}</router-link>
                    </div>
                </li>
                <hr v-if="canView('create_division') || canView('view_division') || canView('create_area') || canView('view_area') || canView('create_zone') || canView('view_zone') || canView('create_hub') || canView('view_hub')"> 
                <h6 v-if="canView('create_division') || canView('view_division') || canView('create_area') || canView('view_area') || canView('create_zone') || canView('view_zone') || canView('create_hub') || canView('view_hub')">
                    {{ $t("common.locations") }}
                </h6>
                <li v-if="canView('create_division') || canView('view_division')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_division', 'edit_division', 'manage_division'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-view_list"></i>
                        <span class="text">{{ $t("division.divisions") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_division')" to="/add-division">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_division')" to="/manage-division">{{ $t("common.manage_list") }}</router-link>
                    </div>
                </li>
                <li v-if="canView('create_area') || canView('view_area')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_area_management', 'manage_area_management', 'edit_area_management'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-crop_original"></i>
                        <span class="text">{{ $t("area.area_Management") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_area')" to="/add-area-management">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_area')" to="/manage-area-management">{{ $t("common.manage_list") }}</router-link>
                    </div>
                </li>
                <li v-if="canView('create_hub') || canView('view_hub')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_hubs', 'manage_hubs'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-collections"></i>
                        <span class="text">{{ $t("hub.hubs") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_hub')" to="/add-hubs">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_hub')" to="/manage-hubs">{{ $t("common.manage_list") }}</router-link> 
                    </div>
                </li>
                <li v-if="canView('create_zone') || canView('view_zone')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_zone_management', 'manage_zone_management', 'edit_zone_management'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-crop_rotate"></i>
                        <span class="text">{{ $t("zone.zone_management") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_zone')"  to="/add-zone-management">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_zone')" to="/manage-zone-management">{{ $t("common.manage_list") }}</router-link> 
                    </div>
                </li>
                <hr v-if="canView('view_sms')">
                <li v-if="canView('view_sms')" class="menu-item has-submenu" :class="[{'active': currentpage(['company_manage', 'iSMS_manage', 'iSMS_create', 'iSMS_edit', 'isms_message_bodies'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-chat"></i>
                        <span class="text">{{ $t("company.company") }}</span>
                    </a>
                    <div class="submenu">
                        <!-- <router-link to="/company-manage">Company Manage</router-link> -->
                        <router-link v-if="canView('view_sms')" to="/iSMS-manage">{{ $t("company.isms_manage")}} </router-link>
                        <!-- <router-link to="/isms-message-bodies">Message Bodies</router-link> -->
                    </div>
                </li>
                <hr v-if="canView('create_role') || canView('view_role') || canView('create_permission') || canView('view_permission') || canView('create_user') || canView('view_user')">
                <h6 v-if="canView('create_role') || canView('view_role') || canView('create_permission') || canView('view_permission') || canView('create_user') || canView('view_user')"> 
                    {{ $t("common.access_control") }}
                </h6>

                <li v-if="canView('create_role') || canView('view_role')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_role', 'manage_role'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-groups"></i>
                        <span class="text">{{ $t("Role.Roles") }} </span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_role')" to="/add-role">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_role')" to="/manage-role">{{ $t("common.manage") }}</router-link>
                    </div>
                </li>
                <li v-if="canView('create_permission') || canView('view_permission')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_permission', 'manage_permission', 'edit_permission'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-person_add"></i>
                        <span class="text">{{ $t("permissions.permissions") }} </span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_permission')" to="/add-permission">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_permission')" to="/manage-permission">{{ $t("common.manage") }}</router-link>
                    </div>
                </li>
                <li v-if="canView('create_user') || canView('view_user')" class="menu-item has-submenu" :class="[{'active': currentpage(['add_user', 'manage_user', 'edit_profile', 'edit_user'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-person"></i>
                        <span class="text">{{ $t("user.users") }}</span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('create_user')" to="/add-user">{{ $t("common.create") }}</router-link>
                        <router-link v-if="canView('view_user')" to="/manage-user">{{ $t("common.manage") }}</router-link>
                    </div>
                </li>

                <hr v-if="canView('details_sales_report')">
                
                <li v-if="canView('details_sales_report')" class="menu-item has-submenu" 
                    :class="[{'active': currentpage(['details_dales_report'])}]">
                    <a class="menu-link"> <i class="icon material-icons md-lightbulb"></i>
                        <span class="text">Report </span>
                    </a>
                    <div class="submenu">
                        <router-link v-if="canView('details_sales_report')" to="/details-dales-report">Datails Sales Report</router-link>
                        <!-- <router-link v-if="canView('view_date_wise_refund')" to="/date-wise-refunds">Date wise refund</router-link> -->
                    </div>
                </li>
            </ul>
           
        </nav>
    </aside>
</template>

<script>
    import $ from "jquery";
    import {checkUserPermission} from "../../script/helper"

    export default {
        data() {
            return {
                currentpage (pages) {
                    if (pages && pages.length) {
                        return pages.includes(this.$route.name);
                    }
                }
            }
        },
        methods: {
            canView(allow) {
                return checkUserPermission(allow);
            }
        },
        mounted: function () {
            $( ".menu-item.has-submenu .menu-link" ).click(function() {
                if ($(this).next(".submenu").is(":hidden")) {
                    $(".has-submenu").siblings().find(".submenu").slideUp(200);

                    $(this).next(".submenu").slideToggle(200)
                } else {
                    $(".has-submenu").siblings().find(".submenu").slideUp(200);
                }
            });

            $(".btn-aside-minimize").on("click", function () {
                window.innerWidth < 768 ? ($("body").removeClass("aside-mini"), $(".screen-overlay").removeClass("show"), $(".navbar-aside").removeClass("show"), $("body").removeClass("offcanvas-active")) : $("body").toggleClass("aside-mini")
            });

            $("[data-trigger]").on("click", function (s) {
                s.preventDefault(), s.stopPropagation();
                var n = $(this).attr("data-trigger");
                $(n).toggleClass("show"), $("body").toggleClass("offcanvas-active"), $(".screen-overlay").toggleClass("show")
            })

            $(".screen-overlay, .btn-close").click(function () {
                $(".screen-overlay").removeClass("show"), $(".mobile-offcanvas, .show").removeClass("show"), $("body").removeClass("offcanvas-active")
            })
        }
    }
</script>